import { render, staticRenderFns } from "./StaticCustomPage.vue?vue&type=template&id=97221366&"
import script from "./StaticCustomPage.vue?vue&type=script&lang=js&"
export * from "./StaticCustomPage.vue?vue&type=script&lang=js&"
import style0 from "./StaticCustomPage.vue?vue&type=style&index=0&id=97221366&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports